import { rgb } from '../../../../../../d3-color/src/color.js';
import '../../../../../../d3-color/src/lab.js';
import '../../../../../../d3-color/src/cubehelix.js';
rgb();
//# sourceMappingURL=sinebow.js.map
